import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SpinnerService } from './services/sppiner/spinner.service';
import { SeoService } from './services/seo/seo.service';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { MenuComponent } from './shared/menu/menu.component';
import { FooterComponent } from './shared/footer/footer.component';
import { LanguageService } from './services/language/language.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SpinnerComponent,
    MenuComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'website-arqit';
  isWelcomeEmailRoute = false;
  isContactConfirmationRoute = false;
  isJobOfferRoute = false;

  constructor(
    private spinnerService: SpinnerService,
    private seoService: SeoService,
    private router: Router,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.spinnerService.show();
    setTimeout(() => this.spinnerService.hide(), 2000);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;

        this.isWelcomeEmailRoute = url === '/welcome-email';
        this.isContactConfirmationRoute = url === '/contact-confirmation';
        this.isJobOfferRoute = url === '/job-offer';
      });
  }
}
